import { DERElement } from '~/common/der-element';
import { property } from 'lit/decorators.js';
import { LocaleCode } from '~/common/interfaces';
import { withTranslations } from '~/ui/utils/mixins';

export default abstract class DERModuleElement extends withTranslations(DERElement) {
    @property({ type: String }) public override lang = LocaleCode.DE_CH;
    @property({ type: String }) public override currency = '';
    @property({ type: String }) public override brand = '';
    @property({ type: String }) public override tenant = 'kuoni';
    @property({ type: Object, attribute: 'additional-tracking-data' }) public override additionalTrackingData = {};
}
